/**
 * 彩蛋接口定义
 */
export interface EggSurpriseI {
    id : string;
    desc : string;
    imgPath : string;
    chooseArray : { chooseName : string , value : number , watchVideoCount ?: number , content ?: string , coins ?: number }[];
}

/**
 *
 * @constructor
 */
export function EggSurpriseConfig() : EggSurpriseI[]{
    const dataList : EggSurpriseI[] = [
        // {
        //     id:"chicken",
        //     desc:"我的鸡啊！这是哪个混蛋干的啊！！你你你，这可是我养了两年半的鸡啊！赔钱",
        //     imgPath:"李阿姨",
        //     chooseArray:[
        //         { chooseName : "8w" ,value : -80000 },
        //     ]
        // },
        // {
        //     id:"seaGod",
        //     desc:"有趣的年轻人哦\t！这是你掉的\t5w！还是50w还是100w呢?不诚实的人是会得到惩罚的哦\t！",
        //     imgPath:"seaGod",
        //     chooseArray:[
        //         { chooseName : "5w" ,value : 0 ,content:"这是你掉的五万（由于你的诚实！海神把150w全部给了你）" ,coins:1500000 },
        //         { chooseName : "50w" ,value : 0 ,watchVideoCount : 1 ,content:"由于你的贪心！海神将你手上的五十万抢走了！" ,coins:-500000},
        //         { chooseName : "100w" ,value : 0 , watchVideoCount : 1 ,content:"不诚实的年轻人哦！海神抢走了你的一百万" ,coins:-1000000},
        //     ]
        // },
    ];
    return dataList;
}

/**
 * 获取 彩蛋 通过id
 * @param id
 */
export function getEggSurpriseById( id : string ) : EggSurpriseI{
    return EggSurpriseConfig().find( ( item ,index , dataList )=>{
        return item.id == id;
    });
}
